var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"list__header"},[_c('h1',[_vm._v(_vm._s(_vm.wording.list.title))]),_c('idf-button',{attrs:{"route":{ name: _vm.routes.edit },"tag":"router-link"}},[_vm._v(_vm._s(_vm.wording.list.create))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }